// extracted by mini-css-extract-plugin
export default {"icon":"VuhV0jIIlLYUjKcMZBLT","pencil":"QHmdsI0MHiaLhsnkD7r1 VuhV0jIIlLYUjKcMZBLT","btn":"WFuPVSh3jylNIiiDPdRG","btns":"D7YmLHY6sGX2GSUGMXzS"};